import { render } from "./OptionsEditableAI.vue?vue&type=template&id=542ee651"
import script from "./OptionsEditableAI.vue?vue&type=script&lang=js"
export * from "./OptionsEditableAI.vue?vue&type=script&lang=js"
script.render = render

export default script